import { FEATURE_FLAG } from "./types";

// Features by default should be disabled
export const FEATURE_CONFIG = {
  //Local feature config flags
  isAdditionalServicesEnabled: false,
  isAddPayerEnabled: true,
  isExternalProjectEnabled: false,
  isRegistrationAddressRequired: false,
  isTaxCollectorDisplayWithModalEnabled:
    false /* LT and PL tax collector logic */,
  isTaxCollectorCategoryGroupingEnabled: false,
  isTaxCollectorRadioEnabled: false /* EE tax collector logic */,
  isDueDateEnabled: false,
  isExpensePlanningEnabled: false,
  isSavingsPlanningEnabled: false,
  isSavedMinutesStatisticsEnabled: false,
  isCustomerStatisticsEnabled: false,
  isBillComparisonEnabled: false,
  isPaperBillDeliveryEnabled: false,
  isBillVariantSelectorEnabled: false /* EE service provider add logic */,
  isHouseAddressOptional: false /* EE house logic */,
  isOverviewBillComparisonEnabled: false,
  isUtilityStatisticsEnabled: false,
  isNonProfitProvidersEnabled: false,
  isPoaEnabled: false,
  isPaymentStatusAdvertEnabled: false,
  isPaymentStatusBudgetActionEnabled: false,
  isHelpPageShortNumberEnabled: false,
  isJbsSummaryProvidersProgressEnabled: false,
  isBudgetEnabled: false,
  isProviderFilteringByCategoryEnabled: false,
  isBankConsentLedgerEnabled: false,
  isServiceProviderStatisticsEnabled: false,
  isRequestedServiceProvidersCollapseEnabled: false,
  isChubbInsuranceEnabled: false,
  isDefaultPlanDiscountEnabled: false,
  isBudgetCustomCategoriesEnabled: false,
  isOnboardingEnabled: false,
  isJointBillServiceDragAndDropEnabled: false,
  isBudgetIncludeTransfersBetweenAccountsInStatisticsSwitchEnabled: false,

  //System feature config flags
  [FEATURE_FLAG.voucherActivation]: false,
};
